// extracted by mini-css-extract-plugin
export default {"sidePanelWrapper":"webview-layout_sidePanelWrapper__FAkge","dark":"webview-layout_dark__O1tMl"};